import type { PrimarySecondaryPageProps } from "@wayflyer/flyui";
import { PrimarySecondaryPage } from "@wayflyer/flyui";
import { OnboardingStepper } from "onboarding";

import { ConnectionsSidePanel } from "../../../components";

export interface ConnectorPageTemplateProps {
  title: string;
  primaryContent: PrimarySecondaryPageProps["primaryContent"];
  secondaryContent?: PrimarySecondaryPageProps["secondaryContent"];
}

export const ConnectorPageTemplate = ({
  title,
  primaryContent,
  secondaryContent = <ConnectionsSidePanel />,
}: ConnectorPageTemplateProps) => {
  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={title}
      primaryContent={primaryContent}
      secondaryContent={secondaryContent}
    />
  );
};
